/**
 * 图片加载失败自动重试
 * 解决用户点击取消后出现裂图的问题
 */

// 最大重试次数
const MAX_RETRIES = 3;

// 存储已经重试过的图片，避免无限重试
const retriedImages = new Map<string, number>();

/**
 * 处理图片加载错误，自动重试
 * @param event 错误事件
 */
function handleImageError(event: Event) {
  const img = event.target as HTMLImageElement;
  if (!img.src) return;
  
  // 获取当前重试次数
  const retryCount = retriedImages.get(img.src) || 0;
  
  // 如果没有超过最大重试次数，则重试
  if (retryCount < MAX_RETRIES) {
    console.log(`图片加载失败，正在重试: ${img.src}, 重试次数: ${retryCount + 1}`);
    
    // 更新重试次数
    retriedImages.set(img.src, retryCount + 1);
    
    // 添加时间戳参数，避免浏览器缓存
    const timestamp = new Date().getTime();
    const separator = img.src.includes('?') ? '&' : '?';
    
    // 延迟一段时间后重试
    setTimeout(() => {
      img.src = `${img.src}${separator}_retry=${timestamp}`;
    }, 300 * Math.pow(2, retryCount)); // 指数退避策略
  } else {
    console.log(`图片 ${img.src} 重试次数已达上限`);
  }
}

/**
 * 注册全局图片错误处理
 */
export function registerImageErrorHandler() {
  // 为所有图片添加错误处理
  document.addEventListener('error', (event) => {
    if (event.target instanceof HTMLImageElement) {
      handleImageError(event);
    }
  }, true); // 使用捕获阶段，确保能捕获到所有图片错误
  
  console.log('已注册全局图片错误处理');
}